import {
  DEFAULT_PROMOTIONS_SORT_COLUMN,
  DEFAULT_PROMOTIONS_SORT_ORDER,
} from "@/core/constants/promotion/promoFilterOptions";
import { FilterDateRange } from "@/presentation/deduction/components/DeductionFilter/interfaces";
import { SelectOption, TableSortInfoColumnType } from "@ir/ui";

type Option = SelectOption;

export interface PromotionsFilterInfo {
  lastFilteredAt: Date | null;
  search: string | null;
  purchaser: Option[];
  promoType: Option[];
  promoStatus: Option[];
  startFromDate: string | null;
  startToDate: string | null;
  startDateRange: FilterDateRange | null;
  sortColumn: string | null;
  sortOrder: TableSortInfoColumnType["order"] | null;
}

export const getEmptyPromotionsFilterInfo = (): PromotionsFilterInfo => ({
  lastFilteredAt: null,
  search: null,
  purchaser: [],
  promoType: [],
  promoStatus: [],
  startFromDate: null,
  startToDate: null,
  startDateRange: null,
  sortColumn: DEFAULT_PROMOTIONS_SORT_COLUMN,
  sortOrder: DEFAULT_PROMOTIONS_SORT_ORDER,
});

export const isDefaultPromotionsFilter = (filterInfo: PromotionsFilterInfo): boolean => {
  return Object.entries(filterInfo)
    .filter(
      ([key]) =>
        key !== "lastFilteredAt" &&
        key !== "sortColumn" &&
        key !== "sortOrder" &&
        key !== "startDateRange"
    )
    .every(([, value]) => {
      if (Array.isArray(value)) {
        return value.length === 0;
      }
      return value === null || value === "" || value === undefined;
    });
};

export const resolvePromotionsSortParams = (
  sortColumn: string | null,
  sortOrder: TableSortInfoColumnType["order"] | null
): { sortColumn: string; sortOrder: TableSortInfoColumnType["order"] } => ({
  sortColumn: sortColumn ?? DEFAULT_PROMOTIONS_SORT_COLUMN,
  sortOrder: sortOrder ?? DEFAULT_PROMOTIONS_SORT_ORDER,
});
